import _jsx from '@babel/runtime/helpers/jsx';
import 'react';
import classnames from 'classnames';
const namespace = 'ui-pdp-title';

/**
 * Title component
 * @typedef {import('../index').Title}
 */
const Title = _ref => {
  let {
    className = '',
    title
  } = _ref;
  return /*#__PURE__*/_jsx("h1", {
    className: classnames(namespace, className)
  }, void 0, title);
};
export { Title };
